<template>
    <div class="container">
        <div class="nav_header">
            <h2>我要提现</h2>
        </div>

        <div class="summary">
            <div class="stat">
                <div class="label">当前可供提现金额</div>
                <div class="value">¥{{ data_summary.allowable || 0 }}</div>
            </div>

            <div class="stat">
                <div class="label">申请中的提现金额</div>
                <div class="value">¥{{ data_summary.pending || 0 }}</div>
            </div>

            <div class="stat">
                <div class="label">历史成功提现金额</div>
                <div class="value">¥{{ data_summary.withdrawn || 0 }}</div>
            </div>

            <div class="stat">
                <el-button @click="on_apply" type="primary" :disabled="!data_summary.allowable">立即申请提现</el-button>
            </div>
        </div>

        <div class="toolbar">
            <div class="left">
                <el-radio-group v-model="status" class="item" @change="(e) => on_field_change(e, 'status')" size="small">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button label="0">处理中</el-radio-button>
                    <el-radio-button label="1">已完成</el-radio-button>
                </el-radio-group>
            </div>
        </div>

        <div v-loading="loading">
            <el-table v-loading="loading" :data="data_source">
                <el-table-column prop="status" label="提现状态" width="80">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success">已完成</el-tag>
                        <el-tag v-if="scope.row.status == -1" type="danger">失败</el-tag>
                        <el-tag v-if="scope.row.status == 0" type="info">处理中</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="withdraw_no" label="提现单号" width="190"> </el-table-column>

                <el-table-column prop="created_at" label="申请时间" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.created_at | dateformat("YYYY-MM-DD HH:mm") }}
                    </template>
                </el-table-column>

                <el-table-column prop="amount_apply" label="申请金额" width="100">
                    <template slot-scope="scope"> ¥{{ scope.row.amount_apply }} </template>
                </el-table-column>
                <el-table-column prop="amount_fee" label="提现费用" width="100">
                    <template slot-scope="scope"> ¥{{ scope.row.amount_fee }} </template>
                </el-table-column>
                <el-table-column prop="amount" label="到款金额" width="100">
                    <template slot-scope="scope"> ¥{{ scope.row.amount }} </template>
                </el-table-column>
                <el-table-column prop="completed_at" label="完成时间" width="150">
                    <template slot-scope="scope" v-if="scope.row.completed_at">
                        {{ scope.row.completed_at | dateformat("YYYY-MM-DD HH:mm") }}
                    </template>
                </el-table-column>
                <el-table-column prop="response_msg" label="提现结果"></el-table-column>
            </el-table>
        </div>

        <el-pagination
            style="text-align:center;margin-top:24px;"
            background
            layout="total,prev, pager, next"
            :total="pagination.total"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            @current-change="handle_current_change"
        >
        </el-pagination>
    </div>
</template>

<script>
 
    export default {
        data() {
            return {
                path: "/finance/withdraw",
                data_source: [],
                data_summary: {},
                status: "",
                loading: false,
            };
        },
        created() {
            this.load();
            this.parse_query();
        },
        watch: {
            $route() {
                this.load();
                this.parse_query();
            },
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/finance/withdraw?" + this.objectToQuery(this.$route.query))
                    .then((response) => {
                        if (response.success) {
                            this.data_source = response.data;
                            this.pagination = response.pagination;

                            this.load_summary();
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            load_summary() {
                this.$http
                    .get("/finance/withdraw/summary")
                    .then((response) => {
                        if (response.success) {
                            this.data_summary = response.data;
                        }
                    })
                    .catch()
                    .then(() => {});
            },
            parse_query() {
                const query = this.$route.query;
                this.status = query["status"] ? query["status"] : "";
            },
            on_apply() {
                this.$confirm("是否立即对账户可提现金额进行提现？", "操作确认", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = "处理中...";

                            this.$http;
                            this.$http
                                .post("/finance/withdraw/apply")
                                .then((response) => {
                                    if (!response.success) {
                                        instance.callback = () => this.$alert(response.message, "失败");
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                                });
                        } else {
                            done();
                        }
                    },
                });
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        .summary {
            display: flex;
            margin: 24px auto;
            .stat {
                margin-right: 24px;
                .value {
                    font-size: 26px;
                    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue,
                        Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
                }
                .label {
                    margin-bottom: 4px;

                    color: rgba(0, 0, 0, 0.45);
                    font-size: 12px;
                }
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
